import React from 'react';

import TvDashboard from 'tvdashboard/TvDashboard';
import TransactionsPage from './transactions/TransactionsPage';
import RouterPaths from './constants/RouterPaths';
import Homepage from './homepage/Homepage';
import DealersPage from './dealers/DealersPage';
import EditDealerPage from './dealers/information/EditDealerPage';
import UsersPage from './users/UsersPage';
import EditUserPage from './users/edit/EditUserPage';
import AdminsPage from './admins/AdminsPage';
import CreateAdminPage from './admins/create/CreateAdminPage';
import VehiclesPage from './vehicles/VehiclesPage';
import EditVehiclePage from './vehicles/edit/EditVehiclePage';
import EditAdminPage from './admins/edit/EditAdminPage';
import SiteCreatorPage from './sitecreator/SiteCreatorPage';
import CreateSitePage from './sitecreator/create/CreateSitePage';
import EditSitePage from './sitecreator/edit/EditSitePage';
import DealerBlacklistPage from './dealers/blacklist/DealerBlacklistPage';
import BidsPage from './bids/BidsPage';
import VehicleBidsPage from './vehicles/bids/VehicleBidsPage';
import VehicleSellPage from './vehicles/sell/VehicleSellPage';
import SettingsPage from './settings/SettingsPage';
import RequestForChangesPage from './requestforchanges/RequestForChangesPage';
import RequestForChangesBadge from './requestforchanges/RequestForChangesBadge';
import { AdminRoleName } from './constants/AdminRole';
import DealerTransactionsPage from './dealers/transactions/DealerTransactionsPage';
import VehicleNotesPage from './vehicles/notes/VehicleNotesPage';

import homePageIcon from './assets/img/icons/home.svg';
import requestForChangesPageIcon from './assets/img/icons/requestForChanges.svg';
import usersPageIcon from './assets/img/icons/users.svg';
import dealersPageIcon from './assets/img/icons/dealers.svg';
import vehiclesPageIcon from './assets/img/icons/vehicles.svg';
import bidsPageIcon from './assets/img/icons/bids.svg';
import transactionsPageIcon from './assets/img/icons/transactions.svg';
import settingsPageIcon from './assets/img/icons/settings.svg';
import adminsPageIcon from './assets/img/icons/admins.svg';
import staticPagesIcon from './assets/img/icons/siteCreators.svg';
import dashboardIcon from './assets/img/icons/statistics.svg';
import invoicesPageIcon from './assets/img/icons/invoices.svg';
import locationPageIcon from './assets/img/icons/location.svg';
import InvoicesPage from './invoices/InvoicesPage';
import InvoiceDetailPage from './invoices/details/InvoiceDetailPage';
import DealerInvoicesPage from './dealers/invoices/DealerInvoicesPage';
import DashboardPage from './dashboard/DashboardPage';
import LocationsPage from './locations/LocationsPage';

const routes = [
  { key: 'menu', label: 'Menu', isTitle: true },
  {
    key: 'home',
    label: 'Home',
    icon: homePageIcon,
    url: '/homepage',
    path: RouterPaths.HOMEPAGE,
    component: Homepage,
    layout: '/user',
    access: AdminRoleName.ADMIN,
  },
  {
    key: 'dashboard',
    label: 'Dashboard',
    icon: homePageIcon,
    url: '/homepage',
    path: RouterPaths.HOMEPAGE,
    component: TvDashboard,
    layout: '/user',
    access: AdminRoleName.DASHBOARD,
  },
  {
    key: 'dashboard',
    label: 'Dashboard',
    icon: dashboardIcon,
    url: '/dashboard',
    path: RouterPaths.DASHBOARD,
    exact: true,
    component: DashboardPage,
    access: AdminRoleName.ADMIN,
  },
  {
    key: 'request-for-changes',
    label: 'Request For Changes',
    icon: requestForChangesPageIcon,
    url: '/request-for-changes',
    path: RouterPaths.REQUEST_FOR_CHANGES,
    component: RequestForChangesPage,
    access: AdminRoleName.ADMIN,
    badge: <RequestForChangesBadge />,
  },
  {
    key: 'users',
    label: 'Users',
    icon: usersPageIcon,
    url: '/users',
    path: RouterPaths.USERS,
    exact: true,
    component: UsersPage,
    access: AdminRoleName.ADMIN,
  },
  {
    key: 'dealers',
    label: 'Dealers',
    icon: dealersPageIcon,
    url: '/dealers',
    path: RouterPaths.DEALERS,
    exact: true,
    component: DealersPage,
    access: AdminRoleName.ADMIN,
  },
  {
    key: 'vehicles',
    label: 'Vehicles',
    icon: vehiclesPageIcon,
    url: '/vehicles',
    path: RouterPaths.VEHICLES,
    exact: true,
    component: VehiclesPage,
    access: AdminRoleName.ADMIN,
  },
  {
    key: 'locations',
    label: 'Locations',
    icon: locationPageIcon,
    url: '/locations',
    path: RouterPaths.LOCATIONS,
    exact: true,
    component: LocationsPage,
    access: AdminRoleName.ADMIN,
  },
  {
    key: 'bids',
    label: 'Bids',
    icon: bidsPageIcon,
    url: '/bids',
    path: RouterPaths.BIDS,
    exact: true,
    component: BidsPage,
    access: AdminRoleName.ADMIN,
  },
  {
    key: 'transactions',
    label: 'Transactions',
    icon: transactionsPageIcon,
    url: '/transactions',
    path: RouterPaths.TRANSACTIONS,
    exact: true,
    component: TransactionsPage,
    access: AdminRoleName.ADMIN,
  },
  {
    key: 'invoices',
    label: 'Invoices',
    icon: invoicesPageIcon,
    url: '/invoices',
    path: RouterPaths.INVOICES,
    exact: true,
    component: InvoicesPage,
    access: AdminRoleName.ADMIN,
  },
  {
    key: 'settings',
    label: 'Fee Settings',
    icon: settingsPageIcon,
    url: '/settings',
    path: RouterPaths.SETTINGS,
    component: SettingsPage,
    access: AdminRoleName.SUPER_ADMIN,
  },
  {
    key: 'admins',
    label: 'Admins',
    icon: adminsPageIcon,
    url: '/admins',
    path: RouterPaths.ADMINS,
    exact: false,
    component: AdminsPage,
    access: AdminRoleName.SUPER_ADMIN,
  },
  {
    key: 'static-pages',
    label: 'Static Pages',
    icon: staticPagesIcon,
    url: '/site-creators',
    path: RouterPaths.SITE_CREATOR,
    exact: true,
    component: SiteCreatorPage,
    access: AdminRoleName.SUPER_ADMIN,
  },
  // additional routes that don't appear in the menu
  {
    path: RouterPaths.CREATE_SITE,
    exact: true,
    component: CreateSitePage,
    access: AdminRoleName.ADMIN,
  },
  {
    path: RouterPaths.EDIT_SITE,
    exact: true,
    component: EditSitePage,
    access: AdminRoleName.SUPER_ADMIN,
  },
  {
    path: RouterPaths.USERS_DEALER,
    component: UsersPage,
    access: AdminRoleName.ADMIN,
  },
  {
    path: RouterPaths.EDIT_USER,
    component: EditUserPage,
    access: AdminRoleName.ADMIN,
  },
  {
    path: RouterPaths.DEALER_INFORMATION,
    exact: true,
    component: EditDealerPage,
    access: AdminRoleName.ADMIN,
  },
  {
    path: RouterPaths.EDIT_VEHICLE,
    component: EditVehiclePage,
    exact: true,
    access: AdminRoleName.ADMIN,
  },
  {
    path: RouterPaths.VEHICLE_BIDS,
    component: VehicleBidsPage,
    access: AdminRoleName.ADMIN,
  },
  {
    path: RouterPaths.VEHICLE_SELL,
    component: VehicleSellPage,
    access: AdminRoleName.ADMIN,
  },
  {
    path: RouterPaths.VEHICLES_NOTES,
    component: VehicleNotesPage,
    access: AdminRoleName.ADMIN,
  },
  {
    path: RouterPaths.VEHICLES_DEALER,
    component: VehiclesPage,
    access: AdminRoleName.ADMIN,
  },
  {
    path: RouterPaths.BIDS_DEALER,
    component: BidsPage,
    access: AdminRoleName.ADMIN,
  },
  {
    path: RouterPaths.CREATE_ADMIN,
    component: CreateAdminPage,
    exact: true,
    access: AdminRoleName.ADMIN,
  },
  {
    path: RouterPaths.EDIT_ADMIN,
    component: EditAdminPage,
    exact: true,
    access: AdminRoleName.ADMIN,
  },
  {
    path: RouterPaths.DEALER_BLACKLIST,
    component: DealerBlacklistPage,
    access: AdminRoleName.ADMIN,
  },
  {
    path: RouterPaths.DEALER_TRANSACTIONS,
    component: DealerTransactionsPage,
    access: AdminRoleName.ADMIN,
  },
  {
    path: RouterPaths.TRANSACTIONS_DEALER,
    component: TransactionsPage,
    access: AdminRoleName.ADMIN,
  },
  {
    path: RouterPaths.INVOICE_DETAIL,
    component: InvoiceDetailPage,
    access: AdminRoleName.ADMIN,
  },
  {
    path: RouterPaths.INVOICES_DEALER,
    component: DealerInvoicesPage,
    access: AdminRoleName.ADMIN,
  },
];

export default routes;
